import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import frCommon from './locales/fr/common.json';
import enCommon from './locales/en/common.json';

const LANGUAGE_STORAGE_KEY = 'app_language';

const getInitialLanguage = () => {
  const saved = localStorage.getItem(LANGUAGE_STORAGE_KEY);
  if (saved === 'fr' || saved === 'en') return saved;
  return navigator.language?.toLowerCase().startsWith('fr') ? 'fr' : 'en';
};

i18n.use(initReactI18next).init({
  resources: {
    fr: { common: frCommon },
    en: { common: enCommon }
  },
  lng: getInitialLanguage(),
  fallbackLng: 'fr',
  defaultNS: 'common',
  interpolation: { escapeValue: false }
});

i18n.on('languageChanged', (lng) => {
  localStorage.setItem(LANGUAGE_STORAGE_KEY, lng);
  document.documentElement.lang = lng;
});

document.documentElement.lang = i18n.language;

export const changeLanguage = (lang: 'fr' | 'en') => i18n.changeLanguage(lang);
export { LANGUAGE_STORAGE_KEY };
export default i18n;
